<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-12" >
          <slot name="header">
            <div class="icon-big text-center"
                 :class="`text-${type}`">
              <img class="clicable" :src="'static/img/icons/' + icon" @click="createNewOrder" />
              <i class="clicable" :class="icon" @click="createNewOrder"></i>
            </div>
          </slot>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <slot name="header">
            <div class="action-text text-center"
                 :class="`text-${type}`">
                 <span class="clicable" @click="createNewOrder">{{title}}</span>
            </div>
          </slot>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'action-card-serviam',
    props:{
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: String,
        description: 'Card title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      },
      method: {
        type: String,
        required: true,
        description: 'Callback method'
      }
    },
    methods: {
        createNewOrder() {
            this.$parent[this.$props.method]()
        }
    }
  }

</script>
<style scoped>
    .card {
        max-height: 130px;
        min-height: 130px;
    }
    .card-content{
        min-height: 130px;
        max-height: 130px;
    }
    .card-category {
        font-weight: bold;
        text-transform: uppercase;
    }
    .card-title {
        font-size: 3em;
        font-style: italic;
    }
    .action-text {
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 4px;
        font-size: 1.1em;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
    }
    .clicable {
        cursor: pointer;
    }
    .text-warning {
      color: #d6752d !important;
    }


</style>
